import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'
import age4049 from '@/assets/landing-age-selection/postmenopausal-40-49.webp'
import age5059 from '@/assets/landing-age-selection/postmenopausal-50-59.webp'
import age6069 from '@/assets/landing-age-selection/postmenopausal-60-69.webp'
import age7080 from '@/assets/landing-age-selection/postmenopausal-70-80.webp'

const schema: LandingScreenSchema = {
	config: {
		funnelFeatureFlag: 'hide_age_selection_screen',
	},

	order: ['LandingHead', 'LandingTitle', 'LandingSubtitle', 'LandingAgeGrid'],

	components: {
		LandingTitle: (): LandingComponentsConfig['LandingTitle'] => ({
			title: 'Intermittent Fasting for <span class="text-accent-gradient">Postmenopausal Women</span>',
			size: 'large',
			uppercase: true,
		}),

		LandingSubtitle: (): LandingComponentsConfig['LandingSubtitle'] => ({
			uppercase: true,
			title: 'BASED ON YOUR <b>AGE</b>',
		}),

		LandingAgeGrid: ({ $t }): LandingComponentsConfig['LandingAgeGrid'] => ({
			theme: 'purple',
			ageRanges: [
				{ value: 40, analyticValue: '40-49', label: $t('female_yoga.pages.landing.age_range.40_49'), img: age4049 },
				{ value: 50, analyticValue: '50-59', label: $t('female_yoga.pages.landing.age_range.50_59'), img: age5059 },
				{ value: 60, analyticValue: '60-69', label: $t('female_yoga.pages.landing.age_range.60_69'), img: age6069 },
				{ value: 70, analyticValue: '70+', label: $t('female_yoga.pages.landing.age_range.70_80'), img: age7080 },
			],
			otherAgesButton: {
				data: { value: 18, analyticValue: '18-39' },
				text: $t('female_yoga.pages.landing.im_young'),
			},
		}),
	},
}

export default schema
